import { Settings } from 'lucide-react';
import { cn } from '@/lib/utils';
import { wizardBlockShellClassName } from '../wizardBlockChrome';

export function TournamentConfigHeader() {
  return (
    <div className={cn(wizardBlockShellClassName, 'text-center')}>
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
        <Settings className="h-8 w-8 text-blue-600" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900">
        Configuración del Torneo
      </h2>
      <p className="mt-2 text-gray-600">
        Define los parámetros generales de tu torneo
      </p>
    </div>
  );
}
